<app-breadcrumb></app-breadcrumb>
<div class="container">
    <div class="container-flight-detail">
        <div class="details-col">
            <div class="map-container">
                <div id="map" [class.dark-theme]="theme$ === 'dark'">
                    <button class="map-reset-btn" (click)="onResetMap()">
                        <i class="pi pi-refresh"></i>
                    </button>
                </div>
            </div>
            <div class="header">
                <div class="tag-sequence">{{sequence?.sequenceNumber}}</div>
                @if(leg?.flightNumber === 0) {
                <div class="tag-misc">Surface/Misc. Duty</div>
                }
                <div class="c-row c-info-row">
                    @if (leg && leg.oalSurfaceAirline) {
                        <div class="tag-container-airline" (click)="op.toggle($event)">
                            <div class="tag-airline">{{leg.oalSurfaceAirline}}</div>
                        </div>
                    }
                    <div class=tag-container>
                        @if (leg?.isCancelled && leg?.isDeadhead) {
                        <div class="tag tag-cancel">{{tag}}</div>
                        }
                        @else if (leg?.isDeadhead) {
                        <div class="tag tag-deadhead">{{tag}}</div>
                        }
                        @else if (leg?.isCancelled) {
                        <div class="tag tag-cancel">{{tag}}</div>
                        }
                        @else {
                        <div class="tag tag-flight">{{tag}}</div>
                        }
                    </div>

                </div>
            </div>
            <div class="card">
                <p-fieldset class="flt-details-fieldset">
                    <ng-template pTemplate="header">
                        <div class="header-title">
                            Flight Details
                            <i class="pi pi-question-circle help-icon" style="color: var(--text-secondary)"
                                (click)="onHelpClicked(0)">
                            </i>
                        </div>
                    </ng-template>
                    @if (leg) {
                    <div class="flight-detials-col">
                        @if(isTimeFormatUTC) {
                            @if (leg.departure.actual && (leg.departure.actual.utc | date: 'yyyy') !== '0001') {
                            <div class="row">
                                Date
                                <div>{{convertDate(leg.departure.actual.utc)}}
                                    <span class="timezone-tag">UTC</span>
                                </div>
                            </div>
                            }
                            @else {
                            <div class="row">
                                Date
                                <div>{{convertDate(leg.departure.scheduled.utc)}}
                                    <span class="timezone-tag">UTC</span>
                                </div>
                            </div>
                            }
                        }
                        @else {
                            @if (leg.departure.actual && (leg.departure.actual.local | date: 'yyyy') !== '0001') {
                            <div class="row row-label">
                                Date
                                <div>{{convertDate(leg.departure.actual.local)}}
                                    <span class="timezone-tag">LCL</span>
                                </div>
                            </div>
                            }
                            @else {
                            <div class="row row-label">
                                Date
                                <div>{{convertDate(leg.departure.scheduled.local)}}
                                    <span class="timezone-tag">LCL</span>
                                </div>
                            </div>
                            }
                        }

                        <div class="row row-label">Flight #<div>AAL{{leg.flightNumber || 0}}</div>
                        </div>

                        <div class="row row-label">Aircraft Type
                            @if(
                                leg.aircraft && 
                                (leg.aircraft.type?.long != null || leg.aircraft.type?.long != undefined)) {
                            <div>{{leg.aircraft.type?.long || ''}}</div>
                            }
                            @else {
                            <div style="font-style: italic; color: var(--text-tertairy)">unknown</div>
                            }
                        </div>
                        <div class="row row-label">Registration
                            @if(
                                leg.aircraft && 
                                (leg.aircraft.faa != null || leg.aircraft.faa != undefined)) {
                            <div class="reg-label" (click)="onRegClicked(leg.aircraft)">{{leg.aircraft.faa || ''}}</div>
                                }
                            @else {
                            <div style="font-style: italic; color: var(--text-tertairy)">unknown</div>
                            }
                
                        </div>

                        <div class="row row-label">Aircraft Nose #
                            @if(
                                leg.aircraft && 
                                (leg.aircraft.id != null || leg.aircraft.id != undefined)) {
                            <div>
                                @if(validateAircraftId(leg.aircraft.id) === 'unknown') {
                                    <div style="font-style: italic; color: var(--text-tertairy)">unknown</div>
                                }
                                @else {
                                    {{validateAircraftId(leg.aircraft.id)}}
                                }
                            </div>
                            }
                            @else {
                            <div style="font-style: italic; color: var(--text-tertairy)">unknown</div>
                            }
                        </div>

                        <div class="row">
                            <div class="station-row row-label">
                                Departure
                                <img style="width: 20px; height: 20px"
                                    [src]="theme$ === 'light' ? takeOffIconLight:takeOffIconDark" />
                            </div>
                            <div class="station-label">{{leg.departureStation.code}}</div>
                        </div>
                        <div class="row">
                            <div class="station-row">
                                Arrival
                                <img style="width: 20px; height: 20px"
                                    [src]="theme$ === 'light' ? landingIconLight:landingIconDark" />
                            </div>
                            <div class="station-label">{{leg.arrivalStation.code}}</div>
                        </div>

                        <div class="row row-label">Distance<div>{{leg.flightDistance.toFixed(1)}}nm</div>
                        </div>
                        @if (!leg.isDeadhead) {
                        <div class="row row-label">Passenger Count<div>{{leg.passengerCount}}</div>
                        </div>
                        }
                    </div>

                    }
                </p-fieldset>

                <p-fieldset class="fieldset">
                    <ng-template pTemplate="header">
                        <div class="header-title">
                            Flight Times
                            <i class="pi pi-question-circle help-icon" (click)="onHelpClicked(1)"></i>
                        </div>
                    </ng-template>


                    @if (leg) {
                    <div class="flight-times-row">
                        <!-- TIME LABEL COLUMN -->
                        <div class="flt-time-col">

                            <div class="sch-row-label">Sched</div>

                            @if ( (leg.departure.rescheduled.local | date: 'yyyy') !== '0001'|| 
                            (leg.arrival.rescheduled.local | date: 'yyyy') !== '0001') {
                            <div class="sch-row-label">ReSched</div>
                            }
                            

                            @if (+leg.flightTimeActual !== 0) {
                            <div class="row-label">Actual</div>
                            }
                        </div>

                        <!-- OUT  COLUMN-->
                        <div class="flt-time-col">
                            <!-- UTC Time Default Set-->
                            <div class="header-row">Out</div>
                            @if(isTimeFormatUTC) {
                                <!-- Scheduled -->
                                <div class="sch-row-label">
                                    {{leg.departure.scheduled.utc| formatTime }}Z

                                    @if(leg.departure.scheduled.local){
                                        <small>({{leg.departure.scheduled.local | formatTime}}L)</small>
                                    }
                                    @else {<div class="empty-block"></div>}
                                </div>
                                <!-- Rescheduled -->
                                    @if ((leg.departure.rescheduled.local | date: 'yyyy') !== '0001' && 
                                        (leg.arrival.rescheduled.local | date: 'yyyy') !== '0001') {
                                        <div class="sch-row-label">
                                            {{leg.departure.rescheduled.utc| formatTime }}Z
                                            @if(leg.departure.rescheduled.local){
                                                <small>({{leg.departure.rescheduled.local | formatTime}}L)</small>
                                            }
                                        </div>
                                    }
                                    @else if ((leg.arrival.rescheduled.utc | date: 'yyyy') !== '0001') {
                                        <div class="empty-block"></div>
                                    }
                                <!-- Actual -->
                                     @if (leg.departure.actual.local && leg.departure.actual.utc && +leg.flightTimeActual !== 0) {
                                         <div class="row-label">{{leg.departure.actual.utc | formatTime}}Z
                                             <small>({{leg.departure.actual.local | formatTime}}L)</small>
                                         </div>
                                     }     
                            }
                            <!-- LOCAL Time Default Set -->
                            @else {
                                <!-- Scheduled -->
                                <div class="sch-row-label">
                                    {{leg.departure.scheduled.local| formatTime }}L

                                    @if(leg.departure.scheduled.utc){
                                        <small>({{leg.departure.scheduled.utc | formatTime}}Z)</small>
                                    }
                                    @else {<div class="empty-block"></div>}
                                </div>
                                <!-- Rescheduled -->
                                    @if ((leg.departure.rescheduled.local | date: 'yyyy') !== '0001' && 
                                        (leg.arrival.rescheduled.local | date: 'yyyy') !== '0001') {
                                        <div class="sch-row-label">
                                            {{leg.departure.rescheduled.local| formatTime }}L
                                        @if(leg.departure.rescheduled.utc){
                                            <small>({{leg.departure.rescheduled.utc | formatTime}}Z)</small>
                                        }
                                        </div>
                                    }
                                    @else if ((leg.arrival.rescheduled.local | date: 'yyyy') !== '0001') {
                                        <div class="empty-block"></div>
                                    }
                                <!-- Actual -->
                                    @if (leg.departure.actual.local && leg.departure.actual.utc && +leg.flightTimeActual !== 0) {
                                        <div class="row-label">{{leg.departure.actual.local | formatTime}}L
                                            <small>({{leg.departure.actual.utc | formatTime}}Z)</small>
                                        </div>
                                    }
                            }
                        </div>

                        <!-- IN COLUMN -->
                        <div class="flt-time-col">
                            <!-- UTC Time Defuault Set -->
                            <div class="header-row">In</div>
                            @if(isTimeFormatUTC) {
                                <!-- Scheduled -->
                                <div class="sch-row-label">
                                    {{leg.arrival.scheduled.utc| formatTime}}Z

                                    @if (leg.arrival.scheduled.local) {
                                    <small>({{leg.arrival.scheduled.local | formatTime}}L)</small>
                                    }
                                </div>
                                <!-- Rescheduled -->
                                @if ((leg.arrival.rescheduled.local | date: 'yyyy') !== '0001' && 
                                    (leg.arrival.rescheduled.local | date: 'yyyy') !== '0001') {
                                    <div class="sch-row-label">
                                        {{leg.arrival.rescheduled.utc| formatTime}}Z
                                        @if (leg.arrival.rescheduled.local) {
                                            <small>({{leg.arrival.rescheduled.local | formatTime}}L)</small>
                                        }
                                    </div>
                                } 
                                 @else if ((leg.departure.rescheduled.utc | date: 'yyyy') !== '0001') {
                                    <div class="empty-block"></div>
                                }
                                <!-- Actual -->
                                @if (leg.arrival.actual.local && leg.arrival.actual.utc && +leg.flightTimeActual !== 0) {
                                    <div class="row-label">{{leg.arrival.actual.utc | formatTime}}Z
                                        <small>({{leg.arrival.actual.local | formatTime}}L)</small>
                                    </div>
                                }
                            }
                            <!-- LOCAL Time Default Set -->
                            @else {
                                <!-- Scheduled -->
                                <div class="sch-row-label">
                                    {{leg.arrival.scheduled.local| formatTime}}L

                                    @if (leg.arrival.scheduled.utc) {
                                        <small>({{leg.arrival.scheduled.utc | formatTime}}Z)</small>
                                    }
                                </div>
                                <!-- Rescheduled  -->
                                    @if ((leg.arrival.rescheduled.local | date: 'yyyy') !== '0001' && 
                                        (leg.arrival.rescheduled.local | date: 'yyyy') !== '0001') {
                                        <div class="sch-row-label">
                                            {{leg.arrival.rescheduled.local| formatTime}}L
                                        @if (leg.arrival.rescheduled.utc) {
                                            <small>({{leg.arrival.rescheduled.utc | formatTime}}Z)</small>
                                        }
                                        </div>
                                    }
                                    @else if ((leg.departure.rescheduled.local | date: 'yyyy') !== '0001') {
                                        <div class="empty-block"></div>
                                    }
                                <!-- Actual -->
                                    @if (leg.arrival.actual.local && leg.arrival.actual.utc && +leg.flightTimeActual !== 0) {
                                        <div class="row-label">{{leg.arrival.actual.local | formatTime}}L
                                            <small>({{leg.arrival.actual.utc | formatTime}}Z)</small>
                                        </div>
                                    }
                            }
                        </div>
                        <!-- BLOCK -->
                        <div class="flt-time-col alt-col">

                            <div class="header-row">Block</div>

                            <div class="sch-row-label">{{leg.flightTimeScheduled | formatMinutes }}</div>

                            @if ((leg.departure.rescheduled.local| date: 'yyyy') !== '0001' || 
                                (leg.arrival.rescheduled.local| date: 'yyyy') !== '0001') {
                                <div class="sch-row-label">{{leg.flightTimeScheduled | formatMinutes}}</div>
                            }

                            @if(leg.flightTimeActual) {
                            <div class="row-label">{{leg.flightTimeActual | formatMinutes }}</div>
                            }
                            <!-- @else {<div class="empty-block"></div>} -->
                        </div>
                    </div>
                    }
                </p-fieldset>

                <p-fieldset>
                    <ng-template pTemplate="header">
                        <div class="header-title">
                            Pilots
                        </div>
                    </ng-template>

                    <div *ngIf="crewMembers$ | async as crewMembers">
                        @if(crewMembers.response && crewMembers.response.length > 0) {
                        <div *ngFor="let crew of crewMembers.response">
                            <div class="c-block-row">
                                <div class="pilots-col c-col">
                                    <div class="c-info-row c-row">
                                        <div class="c-seat-col c-col">
                                            <div>{{crew.seat}}</div>
                                        </div>

                                        <div class="c-name-col">
                                            <div class="c-name-row">{{crew.firstName}} <span *ngIf="crew.nickName">'{{crew.nickName}}'</span> {{crew.lastName}}</div>
                                            <div class="c-empNum-row">{{crew.username}}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="c-contact-col c-col">
                                    <div class="c-info-row c-row">
                                        <img (click)="onContactCrew(crew)" style="height: 34px; width: 34px;"
                                            [src]="theme$ === 'light' ? contactLight:contactDark" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        }
                        @else {
                        <div class="c-not-found">Pilots Not Found</div>
                        }
                    </div>
                    <!-- <ng-template #noCrew>
                            <div class="c-name-row">
                                Crew Not Found
                            </div>
                        </ng-template> -->
                </p-fieldset>
            </div>
        </div>
    </div>
</div>
<p-overlayPanel class="overlay-panel" #op>
    <div class="col">
        <div class="title-overlay">
            Deadhead Airline
        </div>              
        <div class="c-row">
            <div class="code">
                {{leg?.oalSurfaceAirline}}:
            </div>
            <div class="reason-code-description">
                {{airlineCodes[leg?.oalSurfaceAirline || 'unknown']}}
            </div>
        </div>
        @if (leg?.oalSurfaceAirline !== 'AA') {
            <small>Actual flight times not available for Deadheads on 'Other Airlines'.</small>
        }
    </div>
</p-overlayPanel>